// extracted by mini-css-extract-plugin
export default {"employeeContracts":"EmployeeContracts_employeeContracts__5QJ7S","emptyContracts":"EmployeeContracts_emptyContracts__phPHd","footer":"EmployeeContracts_footer__CSRz6"};